import { toast } from "sonner";
import { Copy, Globe, UserPlus } from "lucide-react";
import { RetroWindow } from "./RetroWindow";
import { FlowerLogo } from "../FlowerLogo";
import { SERVER_HOST, SERVER_PORT, copyText } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

export const RetroWelcome = ({ status }) => {
  const { t } = useI18n();
  const addr = `${SERVER_HOST}:${SERVER_PORT}`;
  const copy = async () => {
    await copyText(addr);
    toast.success(t("addrCopied"), { description: addr });
  };
  return (
    <RetroWindow id="top" testid="retro-welcome-window" title={t("rtWelcome")} icon={<FlowerLogo size={16} online={status?.online !== false} />}
      statusbar={<><p>OSCAR · {addr}</p><p className="hidden sm:block">{t(status?.online ? "ONLINE" : status ? "OFFLINE" : "CHECKING")}</p></>}>
      <div className="flex flex-col-reverse sm:flex-row gap-6 items-center">
        <div className="flex-1 min-w-0">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-[#000080]">
            {t("heroA")} {t("heroB")} <span className="text-[#008000]">{t("heroC")}</span>
          </h1>
          <p data-testid="hero-subtitle" className="mt-4 text-base leading-relaxed max-w-2xl">{t("heroSub")}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <a href="#register" className="w98-btn primary" data-testid="hero-register-btn"><UserPlus className="h-4 w-4" />{t("heroRegister")}</a>
            <a href="https://kicq.su" target="_blank" rel="noopener noreferrer" className="w98-btn" data-testid="hero-webclient-btn"><Globe className="h-4 w-4" />{t("heroWeb")}</a>
            <button type="button" onClick={copy} className="w98-btn" data-testid="hero-copy-address-btn"><Copy className="h-4 w-4" />{addr}</button>
          </div>
        </div>
        <div className="w98-sunken bg-white p-4 shrink-0">
          <FlowerLogo size={140} online={status?.online !== false} />
        </div>
      </div>
    </RetroWindow>
  );
};
